









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryDistributionActivityRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import DistributionActivityUserRecordListDialog from './DistributionActivityUserRecordListDialog.vue'


@Component({
  components: {
    VQuery,
    VTable,
    DistributionActivityUserRecordListDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    createTimeDaterange :[],
    createTimes:""
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
      { title: '编号', param: 'id' },
      { title: '绿豆发放名称', param: 'distributionActivityName' },
      { title: '订单号', param: 'orderNo' },
      { title: '分红时间', param: 'createTimeDaterange', type: 'daterange', }
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '编号', param: 'id' },
    { title: '订单号', param: 'orderNo'},
    { title: '绿豆发放名称', param: 'distributionActivityName' },
    { title: '本次预计发放绿豆', param: 'totalNumber' },
    { title: '实际发放绿豆', param: 'actualNumber'},
    { title: '发放人数', param: 'personNumber'},
    { title: '参与人数', param: 'joinPersonNumber'},
    { title: '贡献值总数', param: 'contributionQty'},
    { title: '发放时间', param: 'distributionTime', formatter: DateFormat,width:160 },
    { title: '创建时间', param: 'createTime', formatter: DateFormat,width:160 },
    { title: '平台剩余PV', param: 'currentPlatfotmPv'},
    { title: '单次奖励池比例', param: 'daConfigRate'},
    { title: '奖励池配置的比例', param: 'acRate'},
    { title: '分红执行耗时（ms）', param: 'timeConsuming'},
    { title: '错误信息', param: 'errorMsg',overflow: true},
     {
      title: '操作',
      fixed: 'right',
      operation: [
        { title: '发放流水', click: this.openEditVideo },

      ],
    },

  ]

  public async created() {
    this.loadData()
  }

 public openEditVideo(data: any) {
    const d = this.$refs.DistributionActivityUserRecordListDialog as DistributionActivityUserRecordListDialog
    d.open(data)
  }


  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.createTimeDaterange.length >0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    const result = await QueryDistributionActivityRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
